// @ts-strict-ignore
import { ConnectionAreaVO } from '@shared/vo/meta-element.vo';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { Connection } from '@3d-scene/model3d/connection';
import { ArticleUsageVO } from '@article/model/vo/article.vo';
import { PropertyUtils } from '@article/util/property-utils';
import { ArticleUsageInfoPropertyDef } from '@article/constants/article-usage-info-property-def';

export class CompositeConnectionUtils {
  public static readonly COMPOSITE_GIVING_CONNECTION_POSTFIX: string = '_ca';

  public static constructCompositeGivingConnectionName(originalConnectionName: string, connectionIndex: number): string {
    return originalConnectionName + CompositeConnectionUtils.COMPOSITE_GIVING_CONNECTION_POSTFIX + connectionIndex;
  }

  public static extractOriginalConnectionName(compositeConnectionName: string): string {
    if (!compositeConnectionName) {
      return null;
    }

    const postfixIndex: number = compositeConnectionName.indexOf(CompositeConnectionUtils.COMPOSITE_GIVING_CONNECTION_POSTFIX);
    if (postfixIndex === -1) {
      return compositeConnectionName;
    }
    return compositeConnectionName.substring(0, postfixIndex);
  }

  public static findGivingCubesByCompositeAreas(containers: ArticleContainer[],
                                                givingConnectionAreas: ConnectionAreaVO[]): Connection[] {
    const givingCubes: Connection[] = [];
    for (const givingArea of givingConnectionAreas) {
      const givingCube: Connection = this.findConnectionCubeByCompositeConnectionName(givingArea.name, containers);
      if (givingCube) {
        givingCubes.push(givingCube);
      }
    }
    return givingCubes;
  }

  public static findConnectionCubeByCompositeConnectionName(compositeGivingConnectionName: string,
                                                            sourceContainers: ArticleContainer[]): Connection {
    if (!sourceContainers) {
      return null;
    }

    for (const container of sourceContainers) {
      const connectionNames: string[] = this.getCompositeGivingConnectionNames(container.articleUsage);
      if (connectionNames.indexOf(compositeGivingConnectionName) >= 0) {
        const originalConnectionName: string = this.extractOriginalConnectionName(compositeGivingConnectionName);
        const givingCube: Connection = container.findFirstConnectionByName(originalConnectionName);
        return givingCube;
      }
    }
    return null;
  }

  public static getCompositeGivingConnectionNames(compositePartUsage: ArticleUsageVO): string[] {
    if (!compositePartUsage) {
      return [];
    }
    return PropertyUtils.getStringPropertyValues(compositePartUsage.infoProperties,
      ArticleUsageInfoPropertyDef.COMPOSITE_GIVING_CONNECTION_NAME);
  }
}
